export const EPRO2_ONLY_CT_IDS = [
  'EB_SPICT_02_030',
  'EB_SPICT_02_050',
  'EB_SPICT_02_100',
  'EB_SPICT_02_200',
  'EB_SPICT_02_400',
  'EB_PL01_02_400',
];
